import { Component, OnInit, Input } from '@angular/core';
import { MatTableDataSource, Sort, PageEvent, MatSnackBar } from '@angular/material';
import { AuthenticationService } from '../../../providers/auth.service';
import { InformePersonalizadoService } from '../../../providers/informe-personalizado.service';
import { Informe } from '../../../interfaces/informe';
import { saveAs } from 'file-saver';
import * as moment from 'moment';
import { toArray } from 'rxjs/operator/toArray';
@Component({
  selector: 'app-ver-informes',
  templateUrl: './ver-informes.component.html',
  styleUrls: ['./ver-informes.component.scss']
})
export class VerInformesComponent implements OnInit {
  descargandolistado: boolean = false;
  actualizarTablaTimeout: any; // prevenir muchos llamados consecutivos al webserver
  flag_primera_carga: boolean = true; // primera solicitud a traer datos
  cargandoTimeout: any;
  cargando: boolean = true; // para mostrar el progress-bar luego de un tiempo de busqueda
  tablaInformesColumnas = ['titulo', 'fechaAlta', 'tabla', 'campos', 'condiciones', 'acciones'];
  InformesDataSource = new MatTableDataSource();
  sort: Sort = { active: '', direction: '' };
  page: PageEvent = new PageEvent();
  filtro: string = '';
  informesCount: number = 0;
  @Input() filtrosExternos: any = {}; // filtros que se aplican según el lugar donde se muestran las incidencias
  isLoading: boolean;

  constructor(
    private InformePersonalizadoService: InformePersonalizadoService,
    public authenticationService: AuthenticationService,
    public snackBar: MatSnackBar
  ) {

  }

  ngOnInit() {
    // set valores iniciales
    this.sort.active = 'titulo';
    this.sort.direction = 'asc';
    this.page.pageIndex = 0;
    this.page.pageSize = +localStorage.getItem('itemsPorPagina') || 10;
    this.page.length = 0;
    this.actualizarTabla();
  }

  onFiltro(filterValue: string) {
    this.page.pageIndex = 0;
    this.filtro = filterValue.trim().toLowerCase();
    this.actualizarTabla();
  }

  sortData(sort: Sort) {
    this.page.pageIndex = 0;
    this.sort = sort;
    this.actualizarTabla();
  }

  // onPage(pageEvent: PageEvent) {
  //   localStorage.setItem('itemsPorPagina', pageEvent.pageSize.toString()); // los items por pagina se recuerdan
  //   this.page = pageEvent;
  //   this.actualizarTabla();
  // }

  actualizarTabla(): void {
    clearTimeout(this.actualizarTablaTimeout);
    this.actualizarTablaTimeout = setTimeout(() => {
      clearTimeout(this.cargandoTimeout);
      this.cargandoTimeout = setTimeout(() => { // mostrar cargando si tarda mas de algun tiempo
        this.cargando = true;
      }, 750);


      var filtros: any = { // array de filtros internos
        generico: this.filtro
      };

      this.InformePersonalizadoService
        .getFiltros()
        .subscribe( // suscribimos una nueva busqueda
          respuesta => {
            if (respuesta.estado == 1 && respuesta.informes) {
              if (respuesta.informes) {
                this.informesCount = respuesta.informes.length;
              }
              var informes: Informe[] = []; // array de datos obtenidos
              respuesta.informes.forEach(informe => {
                let data = JSON.parse(informe.data);
                informes.push(
                  new Informe(
                    informe.id,
                    informe.titulo,
                    informe.fecha_creacion,
                    data.tabla,
                    data.campos,
                    JSON.stringify(data.condiciones)
                  )
                )
              });
              this.InformesDataSource.data = informes;
            }
          },
          () => {
            clearTimeout(this.cargandoTimeout); // ya no es necesario mostrar la progress bar
            this.cargando = false; // ocultar progress bar si se estaba mostrando
          },
          () => {
            clearTimeout(this.cargandoTimeout); // ya no es necesario mostrar la progress bar
            this.cargando = false; // ocultar progress bar si se estaba mostrando
          }
        );
        this.isLoading = false;
    }, (this.flag_primera_carga ? 0 : 220));

    this.flag_primera_carga = false;
  }

  descargarFiltro(informe) {

    let resultado: any;
    const data_inicial={};
    let condiciones: any = [];
    const data = JSON.parse(informe.condiciones)
    if(data[0].campo_condicion){
      const data_inicial=informe.condiciones;
      condiciones.push(data[0].campo_condicion + ' ' + data[0].condicion + ' ' + data[0].valor)
    }
    informe.condiciones = condiciones;
    this.InformePersonalizadoService.filtrarInforme({ data: informe }).subscribe((data: any) => {
      const blobData = new Blob([data['archivo']], { type: 'text/csv' });
      saveAs(blobData, 'informe.csv');
      this.descargandolistado = false;
    }
      // respuesta => {
      //   informe.condiciones = data_inicial
      //   if (respuesta.estado == 1) {
      //     if(respuesta.lista.length > 0){
      //       resultado = respuesta;
      //       const titulos = Object.keys(resultado.lista[0]).join(';') + "\r\n";
      //       let datos = resultado.lista.map((a: any) => {
      //         return [
      //           Object.values(a).join(';')
      //         ]
      //       }).join("\r\n");
      //       const fecha = moment().format("YYYYMMDD_HHmmss"); 
      //       const csvConfig = "data:text/csv;charset=utf-8,%EF%BB%BF";
      //       let csvContent = titulos + datos;
      //       let downloadLink = document.createElement("a");
      //       downloadLink.href = csvConfig + encodeURI(csvContent);
      //       downloadLink.download =   fecha + ".csv";

      //       document.body.removeChild(downloadLink);
      //       this.cargando = false;
      //     }else{
      //       this.snackBar.open('Filtro sin resultados.','', { duration: 2750 })
      //     }
      //   }
      // },
      // error => {
      //   this.cargando = false;
      // }
    );
  }
  
  borrarFiltro(informe){
    this.isLoading = true;
    this.InformePersonalizadoService.borrarInforme({"idFiltro":informe} ).subscribe((data: any) =>{
      console.log('Se borro el infrome', data);
      this.actualizarTabla();
      
    },
    (error: any) => {
      console.error('Error al borrar el informe', error);
      this.isLoading = false;
    }); 
  }

  ngOnDestroy() {
  }
}
